module.exports = __webpack_public_path__ + "static/media/kawasaki_logo.8b38043d.png";